
  import {Component, Ref, Vue} from "vue-property-decorator";
  import api from '@/api';
  import PagedTableView from "@/components/PagedTableView/index.vue";
  import UploadTemplate from "@/components/UploadTemplate/index.vue";
  import ExportButton from "@/components/ExportButton/index.vue";
  import ProjectLedgerEdit from "@/views/projects/components/edit-project-legder.vue";
  import {ProjectLedgerDto} from "@/api/appService";
  import filter from "@/utils/filter";

  interface IProjectLedgerQueryForm {
    projectId?:number;
    projectTitle?:string;
    amount?:number;
    amountStart?:number;
    amountEnd?:number;
    occurrenceDate?:string;
    projectBudgetNo?:string;
  }

  @Component({
    components: {ProjectLedgerEdit, ExportButton, UploadTemplate, PagedTableView}
  })
  export default class ProjectLedgerList extends Vue{
    @Ref() readonly projectLedgerEdit!:ProjectLedgerEdit;

    queryForm = {
      projectId: undefined,
      projectTitle:'',
      amount:undefined,
      amountStart:undefined,
      amountEnd:undefined,
      occurrenceDate:undefined,
      projectBudgetNo:undefined
    } as IProjectLedgerQueryForm;

    editId:number = 0;


    created(){
      if(this.$route.params.projectId){
        this.queryForm.projectId = Number(this.$route.params.projectId);
      }
    }


    formatCreationTime(row:any) {
      return filter.formatDate(row.creationTime, undefined);
    }

    formatOccurrenceDate(row:any){
      return filter.formatDate(row.occurrenceDate,'YYYY-MM-DD');
    }

    fetchData(params:any){
      return api.projectLedger.getAll(params);
    }

    handleCreate(){
      (this.projectLedgerEdit as any).show = true;
      this.editId = 0;
    }

    handleEdit(row:ProjectLedgerDto){
      this.editId = row.id!;
      (this.projectLedgerEdit as any).show = true;


    }

    handleDelete(row:ProjectLedgerDto){
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.projectLedger
          .delete({
            id: row.id
          })
          .then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
      });
    }
  }
